__turbopack_context__.v({
  "root": "_5juMiG_root",
  "spinnerImage": "_5juMiG_spinnerImage",
});
